import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch, useStore } from 'react-redux'
import PageContainer from '../fragments/page-container'
import {
	action_fetch_collection,
	action_add_collection_list,
	action_fetch_collection_list,
	action_fetch_collection_sorters,
	action_fetch_collection_filter,
	__Default_Collection_Limit__
} from '../../../../store/actions/pages/collection'

import {
	action_fetch_list_top_banner
} from '../../../../store/actions/global'


import { getTopReminder, fetchAdvertisingDiscount } from '../../../../api'

import List from '../components/list'
import { filterItemsToString, getFilterItemsFromQuery, getTopBanner } from '../utils'
import queryString from 'query-string'
import Empty from '../components/list/empty'
import CacheUtils from '../../../../utils/cache'
import classes from '../style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import { Iconfont } from '../../../components/icon/iconfont'
import FixedRaffle from '../../../layout/fixed-raffle'
import { useApp, useBot, useOnlyList, useQuery } from '../../../hooks/common'

import { useSensors } from '../../../hooks/sensor'

// import BottomSubscribe from '../../../layout/fragments/bottom-subscribe'
import { useRef } from 'react'
import { useCallback } from 'react'
// import IndexLottery from '../../components/index-lottery/rotary-draw/rotary-draw'
// import IndexFixicon from '../../components/index-fixicon'
import BlockImage from '../../../components/image/block-image'
import { useLocation } from 'react-router-dom'
import CountDown from '../../../components/count-down'
import { FormattedMessage } from 'react-intl'
import { generateFilter, SensorsTrack } from '../../../utils/sensor'
import Affix from '../../../components/affix'
import { isFlashSales } from '../../../../utils/product'
import TwitterEvents from '../../../ads/events/twitter'
import BottomBannerTip from '../../details/module/bottom-banner'
import { AlertDiscount, PinterestAlert } from '../../components/index-alert'

const getValidFilterItems = items => {
	const newItems = []

	items?.forEach(item => {
		if (['color', 'size', 'tags', 'category', 'category_ids'].indexOf(item.fieldName) >= 0 || item.fieldName?.indexOf('tags-') === 0) {
			newItems.push(item)
		}
	})
	return newItems
}


const parseSearch = search => {
	const parsed = queryString.parse(search)
	if (parsed && parsed.sort_by) {
		parsed.parentSkus = parsed.sort_by
	}
	return parsed
}

const parseParams = search => {
	if (!search) return
	let newParams = {}
	Object.keys(search).forEach(key => {
		if (search[key] instanceof Array) {
			newParams[key] = search[key]?.filter((value, index, s) => s.indexOf(value) === index).join?.(',')
		} else {
			newParams[key] = search[key]
		}
	})

	if (search?.sort_by) {
		newParams['parentSkus'] = search.sort_by
	}
	return newParams
}

const FlashSaleArea = props =>{
	const { offset, title } = props;

	return <div className={classes.FlashArea}>
	<div className={classes.Hd}>
		<Iconfont className={classes.Icon}>&#xe76a;</Iconfont>
		<span className={classes.Text}>
			{
				title || <FormattedMessage id="flash_sale" defaultMessage="Flash Sale" />
			}
		</span>
	</div>
	<div className={classes.Bd}>
		<div className={classes.CountDown}>
			<span className={classes.EndsIn}>
				<FormattedMessage id="ends_in" defaultMessage="Ends In" />
			</span>
			<CountDown showLabel showHour showDay offset={offset} numberClass={classes.Number} labelClass={classes.Label} dotClass={classes.Dotted} />
		</div>
	</div>
</div>
}

const UtmFlashSaleArea = props =>{
	const [offset, setOffSet] = useState(0);

	useEffect(async () =>{
		if(window.utm_source){
			let response = await fetchAdvertisingDiscount();
			if(response?.code === 200 && response?.result?.endTime){
				const { serverTime, result } = response;
				setOffSet(result?.endTime - serverTime);
			}
		}
	}, []);

	return <React.Fragment>
		{
			offset > 1000 && <FlashSaleArea offset={offset} title={<FormattedMessage id="limit_time_only" defaultMessage="limited time only" />} />
		}
	</React.Fragment>
}

const Collection = props => {

	useStyles(classes)

	const dispatch = useDispatch()
	const isOnlyList = useOnlyList()
	const pageCollection = useSelector((state) => state.pageCollection)
	const global = useSelector(state => state.global)
	const { listTopBanner, listType } = global
	const banner = getTopBanner(listTopBanner, pageCollection?.collection?.id)
	const isBot = useBot()
	const query = useQuery()
	const isApp = useApp()
	const store = useStore()
	const { params } = props.match
	const location = useLocation()
	const search = parseSearch(location.search)
	const filterItems = getFilterItemsFromQuery(search)
	const [value, setValue] = useState(filterItems)
	const [sorter, setSorter] = useState(Number(search['sort']) || 0)
	const [tag, setTag] = useState({
		fieldName: 'tags',
		selections: (search?.tags instanceof Array) ? (search.tags.join(',').split(',').map(s => ({ value: s }))) : (search.tags?.split(',').map(s => ({ value: s })))
	})

	const [min, setMin] = useState(search.minPrice && !isNaN(search.minPrice) ? Number(search.minPrice) : undefined)
	const [max, setMax] = useState(search.maxPrice && !isNaN(search.maxPrice) ? Number(search.maxPrice) : undefined)

	const [showPromotion, setShowPromotion] = useState(false)
	const [topMessage, setTopMessage] = useState(undefined)

	const [sensors, setSensors] = useState(useSensors())

	const flashProduct = pageCollection?.list?.find(p => !!isFlashSales(p))

	const showFlash = query?.ref_type === 'flash'
	const showPreorder = query?.ref_type === 'preorder'

	const filterStr = generateFilter(pageCollection?.filterData, pageCollection?.sorters)

	const [showPinterestAlert, setShowPinterestAlert] = useState(false)



	useEffect(() => {
		if(query?.utm_source){
			setShowPinterestAlert(true)
		}
		TwitterEvents.viewList({products: pageCollection?.list})

		if(pageCollection?.total < 10 || pageCollection?.total < __Default_Collection_Limit__){
			SensorsTrack('List_Result', {product_count: pageCollection?.total || 0})
		}

	}, [])

	useEffect(async () => {
		if (window.__INITIAL_STATE__) {
			// Allow the passed state to be garbage-collected
			delete window.__INITIAL_STATE__
		} else {
			await Collection.fetchData(store, params, search, {})

			window.scrollTo({
				top: 0,
			})

		}
	}, [params.id, location.search, search?.collectionId])

	const initPage = async () => {

	}


	const submitHandle = filterItems => {
		let resultSearch
		if (tag) {
			if (filterItems?.some(f => f.fieldName === 'tags')) {
				resultSearch = filterItemsToString(filterItems)
			} else {
				if (tag.value) {
					resultSearch = filterItemsToString([...filterItems, { fieldName: 'tags', selections: [tag] }])
				} else {
					resultSearch = filterItemsToString([...filterItems])
				}
			}
		} else {
			resultSearch = filterItemsToString(filterItems)
		}

		setValue(filterItems)

		const targetUrl = `${location.pathname}?${resultSearch}`

		if (showFlash && targetUrl?.indexOf('ref_type') < 0) {
			props.history.replace(`${targetUrl}&ref_type=flash`)
		} else if (showPreorder && targetUrl?.indexOf('ref_type') < 0) {
			props.history.replace(`${targetUrl}&ref_type=preorder`)
		} else {
			props.history.replace(targetUrl)
		}

	}

	const handleSorter = sorter => {
		setSorter(sorter)
		props.history.replace(`${location.pathname}?${queryString.stringify({ ...search, sort: sorter })}`)
	}

	const handleTag = tag => {
		setTag(tag)
		const tagSearch = { ...search, tags: tag?.value }
		props.history.replace(`${location.pathname}?${queryString.stringify(tagSearch)}`)
	}

	const onScroll = () => {
		const initialFilterItems = getFilterItemsFromQuery(search)
		const { sorters } = pageCollection

		const requestSorter = (sorters instanceof Array) ? sorters?.[sorter]?.value : sorter
		const filter = {
			collectionId: params.id || search?.collectionId,
			sorter: requestSorter,
			filterItems: getValidFilterItems(initialFilterItems),
		}

		dispatch(action_add_collection_list(filter, { ...search, skip: pageCollection?.skip }, {}))

		if (pageCollection?.skip === 24) {
			const promotionShowed = CacheUtils.get('x_promotion_showed')
			if (!promotionShowed) {
				CacheUtils.set('x_promotion_showed', 1)
				getTopReminder().then(data => data.result).then(remider => {
					setShowPromotion(true)
					setTopMessage(remider)
					setTimeout(() => {
						setShowPromotion(false)
					}, 7000)
				}).catch(data => {
					console.error(data)
				})
			}
		}

	}


	const [showAlert, setShowAlert] = useState(false)
	const timing = useRef()
	const clickRef = useRef(false)

	const touchHandle = useCallback(evt => {
		if (timing.current) {
			clearTimeout(timing.current)
			if (!clickRef.current) {
				timing.current = setTimeout(() => {
					setShowAlert(true)
					clickRef.current = true
				}, 3000)
			}
		}
	}, [])

	const clickHandle = useCallback(evt => {
		clickRef.current = true
		if (timing.current) {
			clearTimeout(timing.current)
		}
	}, [])


	useEffect(() => {
		timing.current = setTimeout(() => {
			setShowAlert(true)
			clickRef.current = true
		}, 3000)

		window.addEventListener('touchstart', touchHandle)
		window.addEventListener('click', clickHandle)

		return () => {
			clearTimeout(timing.current)
			window.removeEventListener('touchstart', touchHandle)
		}
	}, [])



	return <div>

		{
			isOnlyList ? <List isGift product_type={'gift'} products={pageCollection.list} request={onScroll} loading={pageCollection?.loading} finished={pageCollection?.finished} /> : <React.Fragment>
				{
					showPromotion && topMessage && <div className={classes.TopPromotion}>
						<svg t="1634626847376" className={classes.PIcon} viewBox="0 0 1122 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="25828" width="200" height="200"><path d="M715.741001 99.346832l142.256619 31.205317c49.796421 10.665944 88.497619 47.980239 99.592842 95.927456l62.410634 262.653007c8.717676 25.888856 1.585032 54.815689-18.161824 73.836072L660.429989 891.862819" fill="#FFFFFF" p-id="25829"></path><path d="M606.340773 973.756138l396.257993-402.99438a75.619234 75.619234 0 0 0 17.534416-75.289018l-60.297258-267.936447a127.628095 127.628095 0 0 0-96.191627-97.842703l-264.171996-59.768914a72.581256 72.581256 0 0 0-74.034202 17.83161L15.454062 606.524042a54.551517 54.551517 0 0 0 0 76.081535l263.379479 267.903425c2.311505 2.311505 5.349483 4.656031 7.627967 7.000558a245.184633 245.184633 0 0 0 325.261769 9.312063" fill="#E64545" p-id="25830"></path><path d="M712.802087 377.189729a66.042999 66.042999 0 1 0 93.3848-93.384801 66.042999 66.042999 0 0 0-93.3848 93.384801z" fill="#FFFFFF" p-id="25831"></path><path d="M1045.526715 330.629414a317.237545 317.237545 0 0 1-59.735892 47.881174 22.322534 22.322534 0 0 1-6.042934 3.137043l-12.085869-55.740291A235.179119 235.179119 0 0 0 1008.476593 292.192389c33.285671-34.540488 54.452453-76.114556 60.495387-116.896108 5.28344-38.470047-3.037978-71.425503-24.204759-93.384801-46.131035-47.881174-136.841094-30.61093-202.619921 37.64451-5.28344 5.481569-10.56688 10.996159-15.123846 17.270244-24.204759 30.61093-40.055079 65.118397-45.371541 99.658885 0 2.311505-0.759494 4.689053-0.759494 6.274085-3.764451 35.299983 5.28344 65.910913 24.964254 86.285178 6.802429 7.066601 15.123847 12.54817 24.204759 17.270245 3.764451 1.585032 7.561923 3.96258 11.326374 6.274084 1.518989 0.792516 3.037978 2.377548 4.556967 3.96258a83.577415 83.577415 0 0 1-15.883341 24.303824 81.464039 81.464039 0 0 1-21.926276 15.685212h-0.759495a140.836695 140.836695 0 0 1-39.295584-28.233382c-27.242737-28.266404-40.847595-65.910913-41.607089-109.070013 0-10.236665 0.759494-20.407287 2.278483-31.370424 5.28344-36.12552 19.647792-72.218019 40.814574-105.173476a295.212205 295.212205 0 0 1 34.012144-42.366584c86.186114-89.455242 210.941338-106.725486 277.47966-37.644509 67.297816 69.014934 51.414475 198.492233-35.531134 287.947475zM627.408489 937.135295a184.259967 184.259967 0 0 1-27.440866 18.227867c-83.874609 48.640669-193.704116 47.286787-276.059735-3.368193A231.44769 231.44769 0 0 1 297.193495 933.07365c1.518989 0 3.037978-0.66043 5.349483-0.66043 45.734777 1.32086 103.687508-10.79803 141.82734-32.427112 19.8129-11.45846 45.767798-10.79803 64.061709 2.047333 38.139832 27.672017 83.874609 35.101854 118.976462 35.101854z" fill="#DE1313" p-id="25832"></path><path d="M508.531091 330.497328a76.279664 76.279664 0 0 0-76.114556 76.708944 76.279664 76.279664 0 0 0 76.081535 76.741964 76.279664 76.279664 0 0 0 76.114556-76.741964A76.279664 76.279664 0 0 0 508.49807 330.497328z m0 112.471227a35.630198 35.630198 0 0 1-35.498111-35.762283c0-19.350599 15.520105-35.729262 35.46509-35.729263 19.218513 0 35.46509 15.619169 35.46509 35.729263 0 20.143115-15.520105 35.762284-35.46509 35.762283z m193.57203 163.126208H321.563362A24.700082 24.700082 0 0 1 297.193495 581.526767c0-13.43975 11.095224-24.601017 24.369867-24.601017h380.539759c13.274643 0 24.369867 11.161267 24.369867 24.601017a24.237781 24.237781 0 0 1-24.369867 24.567996z m-195.817491 66.274149a76.279664 76.279664 0 0 0-76.081535 76.741965A76.279664 76.279664 0 0 0 506.28563 825.81982a76.279664 76.279664 0 0 0 76.114556-76.708943 76.279664 76.279664 0 0 0-76.114556-76.741965z m0 112.471227a35.630198 35.630198 0 0 1-35.465091-35.729262c0-19.38362 15.520105-35.762284 35.465091-35.762284 19.218513 0 35.46509 15.652191 35.46509 35.762284 0 19.350599-16.246578 35.729262-35.46509 35.729262z" fill="#FFFFFF" p-id="25833"></path></svg>
						<span className={classes.Text} dangerouslySetInnerHTML={{ __html: topMessage }} />


						<Iconfont onClick={e => {
							e.preventDefault();
							e.stopPropagation();
							setShowPromotion(false);
							if (window.GeekoSensors) {
								window.GeekoSensors.Track("ELClick", {
									clicks: '列表引导弹出关闭'
								})
							}
						}} className={classes.CIcon}>
							&#xe69a;
						</Iconfont>
					</div>
				}


				<PageContainer links={[
					{
						href: '#',
						title: pageCollection?.collection?.name,
						keywords: [],
					}
				]}
					extra={() => {
						return <>
							{
								banner && banner.src && <div className={classes.Banner}>
									{
										banner?.isFlash && pageCollection?.list?.length > 0 && <div className={classes.Timmer}>
											<div className={classes.Title}>
												<FormattedMessage id="ends_in" defaultMessage="Ends In" />:
											</div>
											<CountDown showLabel showHour showDay offset={flashProduct?.promotion?.endTime - flashProduct?.promotion?.serverTime} numberClass={classes.Number} labelClass={classes.Label} dotClass={classes.Dotted} />
										</div>
									}


									<BlockImage sensors={{
										position: 1,
										content: banner.refId,
										type: '1',
										title: 'list'
									}} href={banner.href} title={banner.title} src={banner.src} width={banner.width} height={banner.height} />
								</div>
							}


							{
								showFlash && !!flashProduct ? <React.Fragment>
									<FlashSaleArea offset={flashProduct?.promotion?.endTime - flashProduct?.promotion?.serverTime} />
								</React.Fragment> : <React.Fragment>
									<UtmFlashSaleArea />
								</React.Fragment>
							}


						</>
					}}
					total={pageCollection?.total}
					filterVo={pageCollection?.filterVo}
					sorters={pageCollection?.sorters}
					onSubmit={submitHandle}
					value={value}
					sorter={sorter}
					onSorter={handleSorter}
					onTag={handleTag}
					tag={tag}
					showBottomTools={query?.ref === 'promotion' || query?.ref === 'gifts'}
					showGiftsTools={query?.ref === 'gifts'}
				>
					{
						pageCollection?.finished && (!pageCollection?.list || pageCollection?.list?.length < 1) ? <Empty /> : <List listType={listType} isPreOrder={showPreorder} isFlash={showFlash} filter={filterStr} sensors={sensors} products={pageCollection.list} request={onScroll} loading={pageCollection?.loading} finished={pageCollection?.finished} />
					}
				</PageContainer>

				<BottomBannerTip isFixed />

				{
					!isBot && (query.utm_source == 'facebook' || query.utm_source == 'google') && showAlert && <React.Fragment>
						{/* <BottomSubscribe ignoreTouch/> */}
						<FixedRaffle />
					</React.Fragment>
				}

			</React.Fragment>
		}

		{showPinterestAlert && <PinterestAlert />}

		{/* <IndexLottery /> */}
		{/* <IndexFixicon /> */}
	</div>
}




Collection.fetchData = async (store, params, search, headers) => {

	const initialFilterItems = getFilterItemsFromQuery(search)
	const sort = search.sort || 0
	const sorters = await store.dispatch(action_fetch_collection_sorters({}, headers))
	const sorter = (sorters instanceof Array) ? sorters?.[sort]?.value : sort
	const collectionId = params.id || search?.collectionId

	const filter = {
		collectionId,
		sorter: sorter,
		filterItems: getValidFilterItems(initialFilterItems),
	}

	// console.log(parseParams(search))

	const values = await Promise.all([
		store.dispatch(action_fetch_collection(collectionId, headers)),
		store.dispatch(action_fetch_collection_list(filter, parseParams(search), headers)),
		store.dispatch(action_fetch_collection_filter({ collectionId }, headers)),
		store.dispatch(action_fetch_list_top_banner(headers)),
	])
	return [...values, sorters]
}

export default Collection
